export default "https://cdn-web.disco.co/slack-logo-e313c3980fc93771b886d61374a6cc92.png";